import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NgbDate, NgbDatepicker, NgbDateStruct, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { AlertService } from 'src/app/services/alert/alert.service';
import { TranslateConfigService } from 'src/app/services/translate/translate-config.service';

const INPUT_FORMAT = 'DD/MM/YYYY';

const parseDate = (date): NgbDateStruct => {
  const d = moment(date);
  const year = d.year();
  const month = d.month() + 1;
  const day = d.date();
  return { year, month, day };
};

@Component({
  selector: 'modal-datetime',
  templateUrl: 'modal-datetime.component.html',
  styleUrls: ['modal-datetime.component.scss'],
})
export class ModalDateTimeComponent implements OnInit {

  @Input() title: string;
  @Input() minDate: string | Date;
  @Input() maxDate?: string | Date;
  @Input() checkFast: boolean;

  ngbDate: NgbDateStruct;
  ngbMinDate: NgbDateStruct;
  ngbMaxDate: NgbDateStruct;

  disabled: boolean = true;

  constructor(
    private modal: ModalController,
    private alert: AlertService,
    private config: NgbDatepickerConfig,
    private translateConfigService: TranslateConfigService
  ) {
    const lang = this.translateConfigService.getCurrentLanguage();
    if (lang === 'it') {
      this.config.firstDayOfWeek = 1; // start with lunedì
    } else {
      this.config.firstDayOfWeek = 2; // start with monday
    }
  }

  ngOnInit(): void {
    this.ngbMinDate = parseDate(this.minDate);
    this.ngbMaxDate = parseDate(this.maxDate ? moment(this.maxDate) : moment(this.minDate).add(5, 'years'));
  }

  onSelected() {
    this.disabled = false;
  }

  async confirm() {
    if (this.checkFast == true) {
      if (!this.isAdult()) {
        await this.alert.translate('ADULT_PROFILE_ERROR');
        this.disabled = true;
        this.ngbDate = new NgbDate(1, 1, 1970);     
        return;
      }
    }
    
    /*await this.alert.confirm({
      titleKey: 'Conferma data',
      messageKey: `${this.ngbDate.day}-${this.ngbDate.month <= 10 ? '0' + this.ngbDate.month : this.ngbDate.month}-${this.ngbDate.year}`,
      cancelHandler: async () => false, 
      okHandler: async () => {
        const { year, month, day } = this.ngbDate;
        const date = moment({ year, month: month - 1, day });
        this.closeWithData(date);
      }
    });*/
    const { year, month, day } = this.ngbDate;
    const date = moment({ year, month: month - 1, day });
    this.closeWithData(date);
  }

  isAdult() {
    const { year, month, day } = this.ngbDate;
    const birthday = moment({ year, month: month - 1, day });

    const age = moment().diff(moment(birthday), 'years');
    return age >= 18;
  }

  close() {
    this.modal.dismiss();
  }

  closeWithData(date) {
    this.modal.dismiss({ date });
  }

}
